const SECONDS_PER_ROUND = 6; // Always 6 seconds per round
const ROUNDS_PER_EPOCH_DEVNET = 2400;  // 4 hours (2400 * 6s = 14400s = 4h)
const ROUNDS_PER_EPOCH_MAINNET = 14400; // 24 hours (14400 * 6s = 86400s = 24h)

export function epochToDate(targetEpoch, currentEpoch, isDevnet = true) {
    const roundsPerEpoch = isDevnet ? ROUNDS_PER_EPOCH_DEVNET : ROUNDS_PER_EPOCH_MAINNET;
    const epochDiff = targetEpoch - currentEpoch;
    
    // Calculate total seconds to add
    const totalSeconds = epochDiff * roundsPerEpoch * SECONDS_PER_ROUND;
    
    return new Date(Date.now() + totalSeconds * 1000);
}